import axios from 'axios';

export interface WorkOrderPhotoDto {
  Oid: string;
  WorkOrderOid: string;
  FileName: string;
  ContentType: string;
  FileSize: number;
  UploadedAt: string;
  UploadedBy: string;
}

function getHeaders(token: string) {
  return { headers: { Authorization: `Bearer ${token}` } };
}

/** Return the URL to stream a photo (use as <img src=...>) */
export function getPhotoUrl(workOrderOid: string, photoId: string): string {
  return `${process.env.REACT_APP_URL}/api/WorkOrder/${workOrderOid}/Photos/${photoId}`;
}

/** List all photos for a work order */
export async function getWorkOrderPhotos(token: string, workOrderOid: string): Promise<WorkOrderPhotoDto[]> {
  const res = await axios.get(
    `${process.env.REACT_APP_URL}/api/WorkOrder/${workOrderOid}/Photos`,
    getHeaders(token)
  );
  return res.data;
}

/** Upload one or more photos (multipart/form-data) */
export async function uploadWorkOrderPhotos(
  token: string,
  workOrderOid: string,
  files: File[]
): Promise<WorkOrderPhotoDto[]> {
  const formData = new FormData();
  files.forEach((f) => formData.append('photos', f));
  const res = await axios.post(
    `${process.env.REACT_APP_URL}/api/WorkOrder/${workOrderOid}/UploadPhotos`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return res.data;
}

/** Delete a single photo */
export async function deleteWorkOrderPhoto(token: string, workOrderOid: string, photoId: string): Promise<void> {
  await axios.delete(
    `${process.env.REACT_APP_URL}/api/WorkOrder/${workOrderOid}/Photos/${photoId}`,
    getHeaders(token)
  );
}
